<mat-toolbar class="app-nav">
  <!-- LEFT SIDE -->
  <div class="app-nav-left">
    <!-- Logo -->
    <img src="assets/logos/SVG/Handle_Wordmark.svg" alt="Handle" class="app-logo-img" />

    <!-- Search -->
    <div class="app-nav-search">
      <mat-form-field appearance="outline" class="searchBar">
        <mat-icon matPrefix aria-hidden="true">search</mat-icon>
        <input
          matInput
          type="text"
          placeholder="Search careers, mentors, opportunities..."
          aria-label="Search careers, mentors, and opportunities"
          [formControl]="searchControl"
          [matAutocomplete]="auto"
          (input)="onInput()"
          (keyup.enter)="onEnter()"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          class="student-nav-search-autocomplete"
          (optionSelected)="onOptionSelected($event)"
        >
          @for (option of searchOptions; track option.target) {
            <mat-option [value]="option.target">
              {{ option.label }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  <!-- Spacer -->
  <span class="nav-spacer" aria-hidden="true"></span>

  <!-- RIGHT SIDE -->
  <nav class="app-nav-right" aria-label="Main navigation">
    <!-- HOME -->
    <a
      mat-button
      class="app-nav-item"
      routerLink="/students"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      aria-label="Home"
    >
      <mat-icon aria-hidden="true">home</mat-icon>
      <span>Home</span>
    </a>

    <!-- NETWORK -->
    <a
      *hasPermission="P.STUDENTS.VIEW_NETWORK"
      mat-button
      class="app-nav-item"
      routerLink="/network"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      aria-label="Network"
    >
      <mat-icon aria-hidden="true">people</mat-icon>
      <span>Network</span>
    </a>

    <!-- MESSAGES -->
    <a
      *hasPermission="P.MESSAGING.VIEW"
      mat-button
      class="app-nav-item"
      routerLink="/messages"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      aria-label="Messages"
    >
      <mat-icon aria-hidden="true">chat_bubble_outline</mat-icon>
      <span>Messages</span>
    </a>

    <!-- MEETINGS -->
    <a
      *hasPermission="P.CALENDAR.VIEW"
      mat-button
      class="app-nav-item"
      routerLink="/meetings"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      aria-label="Meetings"
    >
      <mat-icon aria-hidden="true">perm_contact_calendar</mat-icon>
      <span>Meetings</span>
    </a>

    <!-- CAREERS -->
    <a
      *hasPermission="P.CAREER.VIEW"
      mat-button
      class="app-nav-item"
      routerLink="/careers"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      aria-label="Careers"
    >
      <mat-icon aria-hidden="true">work_outline</mat-icon>
      <span>Careers</span>
    </a>

    <a
      *hasPermission="P.CALENDAR.VIEW"
      mat-button
      class="app-nav-item"
      data-testid="nav-calendar"
      routerLink="/students/calendar"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      aria-label="Calendar"
    >
      <mat-icon aria-hidden="true">calendar_month</mat-icon>
      <span>Calendar</span>
    </a>

    <app-alerts-menu #alerts [origin]="alertsTrigger" />

    <button
      mat-button
      class="app-nav-item"
      cdkOverlayOrigin
      #alertsTrigger="cdkOverlayOrigin"
      (click)="alerts.toggle()"
      aria-label="Alerts and notifications"
    >
      @let alertCount = (alertsService.unreadCount$ | async) ?? 0;
      <mat-icon
        aria-hidden="true"
        [matBadge]="alertCount"
        [matBadgeHidden]="alertCount === 0"
        matBadgeColor="warn"
      >
        notifications_none
      </mat-icon>
      <span>Alerts</span>
    </button>

    <!-- Avatar Button -->
    <button
      mat-icon-button
      class="app-nav-avatar"
      [matMenuTriggerFor]="avatarMenu"
      aria-label="Open profile menu"
      aria-haspopup="true"
    >
      @if (avatarUrl) {
        <img [src]="avatarUrl" alt="Profile photo" class="app-nav-avatar-img" />
      } @else {
        <span aria-hidden="true">{{ initials }}</span>
      }
    </button>

    <!-- Dropdown Menu -->
    <mat-menu #avatarMenu="matMenu" class="student-nav-account-menu" xPosition="before">
      <a *hasPermission="P.PROFILE.EDIT_OWN" mat-menu-item routerLink="/profilePage">
        <mat-icon aria-hidden="true">person_outline</mat-icon>
        <span>View Profile</span>
      </a>
      <a mat-menu-item routerLink="/settings">
        <mat-icon aria-hidden="true">settings</mat-icon>
        <span>Settings</span>
      </a>
      <a mat-menu-item routerLink="/privacy">
        <mat-icon aria-hidden="true">description</mat-icon>
        <span>Privacy Agreement</span>
      </a>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()" class="danger" aria-label="Log out">
        <mat-icon aria-hidden="true">logout</mat-icon>
        <span>Log Out</span>
      </button>
    </mat-menu>
  </nav>
</mat-toolbar>
